import { create } from 'zustand';

import type { AnalyticsAdapter } from '@/adapters/analytics/types';
import { ANALYTICS_EVENTS, ANALYTICS_PARAMS } from '@/constants/analytics';

export interface ScreenAnalyticsAdapters {
  analytics: AnalyticsAdapter;
}

export interface ScreenAnalyticsActions {
  trackScreenView: (screenName: string) => void;
}

export const createScreenAnalyticsStore = (adapters: ScreenAnalyticsAdapters) =>
  create<ScreenAnalyticsActions>(() => ({
    trackScreenView: (screenName: string) => {
      adapters.analytics.track(ANALYTICS_EVENTS.APP_SCREEN_VIEWED, {
        [ANALYTICS_PARAMS.SCREEN_NAME]: screenName,
      });
    },
  }));
